<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      line-form
      form-label-width="110px"
      title="选择对账条件"
      :data="data"
      :form-rules="rules"
      @closed="onClosed"
    >
      <template slot="form">
        <el-form-item label="供应商名称">
          <select-input
            placeholder="请选择供应商"
            :label="data.TradeUnitName"
            v-model="data.TradeUnitId"
            @click="openTradeunit"
          />
        </el-form-item>
        <el-form-item label="对账周期">
          <el-select v-model="data.Cycle" @change="cycleChange">
            <el-option value="今天"></el-option>
            <el-option value="昨天"></el-option>
            <el-option value="近3天"></el-option>
            <el-option value="近7天"></el-option>
            <el-option value="近14天"></el-option>
            <el-option value="本周"></el-option>
            <el-option value="上周"></el-option>
            <el-option value="本月"></el-option>
            <el-option value="上月"></el-option>
            <el-option value="本季"></el-option>
            <el-option value="上季"></el-option>
            <el-option value="本年"></el-option>
            <el-option value="上年"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对账日期">
          <range-picker
            style="border: none;margin-left: 9px;"
            :date="[data.DateStart, data.DateEnd]"
            @change="x=>{data.DateStart=x.Start;data.DateEnd=x.End;}"
          />
        </el-form-item>
        <el-form-item label="销售订单号">
          <el-input v-model="data.SalesOrderNo" placeholder="请填写销售订单号"></el-input>
        </el-form-item>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
      <!-- 后面补充 -->
      <tradeunit-dialog ref="tradeunitDialog" in-dialog selectable @select="setTradeunit" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    tradeunitDialog
  },
  data() {
    return {
      // api: require("@/api/ba/abstract").default,
      data: {
        BusinessType: 0, //收款核销/付款核销
        TradeUnitId: null,
        TradeUnitName: "",
        DateStart: null,
        DateEnd: null,
        SalesOrderNo: "",
      },
      isSave: false,
      saveDto: null,
      rules: {
        TradeUnitId: [{ required: true, message: "请选择供应商" }],
      },
    };
  },
  methods: {
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData({ TradeUnitTypes: [1, 2]});
      });
    },
    setTradeunit(data) {
      this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.FullName;
    },
    save() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;

        this.isSave = true;
        this.saveDto = { ...this.data };
        this.close(true);
      });
    },
    onClosed() {
      if (this.isSave) this.$emit("confirm", { ...this.saveDto });
      this.isSave = false;
    },

    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }
      this.data.DateStart = start;
      this.data.DateEnd = end;
    },
  },
};
</script>